var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91542 18.6207H7.79069C5.02854 18.6207 2.83298 16.4828 2.83298 13.7931V11.0345H4.24947V13.7931C4.24947 15.7241 5.8076 17.2414 7.79069 17.2414H9.91542V18.6207ZM18.4144 20H19.9725L16.7146 12.4138H15.1564L11.8985 20H13.4566L14.0232 18.6207H17.7769L18.4144 20ZM14.6607 17.2414L15.9355 14.2069L17.2103 17.2414H14.6607ZM18.4144 9.65517H16.9979V6.89655C16.9979 4.96552 15.4397 3.44828 13.4566 3.44828H10.6237V2.06897H13.4566C16.2188 2.06897 18.4144 4.2069 18.4144 6.89655V9.65517ZM8.49893 2.75862V1.37931H4.95771V0H3.54122V1.37931H0V2.75862H5.8076C5.66596 3.37931 5.24101 4.48276 4.24947 5.51724C3.82452 5.03448 3.4704 4.55172 3.25792 4.13793H1.62896C1.91226 4.82759 2.40803 5.65517 3.11628 6.41379C2.54968 6.89655 1.69979 7.31035 0.708245 7.65517L1.20402 8.96552C2.47886 8.48276 3.4704 7.93103 4.24947 7.37931C5.02854 8 6.02008 8.55172 7.29492 8.96552L7.79069 7.65517C6.79915 7.31035 5.94925 6.82759 5.31183 6.41379C6.6575 5.03448 7.08244 3.58621 7.22409 2.75862H8.49893Z",
    fill: "#F6F8FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLang);
export default __webpack_public_path__ + "static/media/lang.0c282f2f2644cd876a3547fefe691896.svg";
export { ForwardRef as ReactComponent };